export default __webpack_public_path__ + "static/winter37-bbe32b715e432965fe9c4f8ed7d9d1ea.webp";